"use client";

import { c as _c } from "react/compiler-runtime";
import { useStytchMember } from "@stytch/nextjs/b2b";
import { createContext, useContext, type ReactNode } from "react";
import { useGroup } from "@/src/lib/data-fetchers/group-fetchers";
import { Group } from "@/src/models/group";
interface UserContextProps {
  email: string | null;
  stytchOrgId: string | null;
  group: Group | null;
  tenancy: string | null;
  roles: string[];
}
const UserContext = createContext<UserContextProps | undefined>(undefined);
const EMPTY_USER_CONTEXT: UserContextProps = {
  email: null,
  stytchOrgId: null,
  group: null,
  tenancy: null,
  roles: []
};
export const UserProvider = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const {
    member
  } = useStytchMember();
  const {
    data: group
  } = useGroup(member?.organization_id);
  let t1;
  if ($[0] !== group || $[1] !== member) {
    t1 = member && group ? {
      email: member.email_address || "",
      stytchOrgId: member.organization_id,
      group,
      tenancy: group.tenancy,
      roles: member.roles?.map(_temp) || []
    } : EMPTY_USER_CONTEXT;
    $[0] = group;
    $[1] = member;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const userState = t1;
  let t2;
  if ($[3] !== children || $[4] !== userState) {
    t2 = <UserContext.Provider value={userState}>{children}</UserContext.Provider>;
    $[3] = children;
    $[4] = userState;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
function _temp(role) {
  return role.role_id;
}